export const SET_USER_LIST = 'SET_USER_LIST';
export const RESET_USER_LIST = 'RESET_USER_LIST';
export const SET_PROVIDER_LIST = 'SET_PROVIDER_LIST';
export const RESET_PROVIDER_LIST = 'RESET_PROVIDER_LIST';
